import { render, staticRenderFns } from "./CategoryEditModal.vue?vue&type=template&id=ae9e2a5a&"
import script from "./CategoryEditModal.vue?vue&type=script&lang=ts&"
export * from "./CategoryEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports